"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseJSON = exports.checkStatus = exports.OTP_LOGIN_MODE = exports.EMAIL_LOGIN_MODE = exports.API_ROOT = void 0;
var API_ROOT = process.env.LOGIN_BASE_API_ROOT || "/api/web/vdev/";
exports.API_ROOT = API_ROOT;
var EMAIL_LOGIN_MODE = 1;
exports.EMAIL_LOGIN_MODE = EMAIL_LOGIN_MODE;
var OTP_LOGIN_MODE = 2;
exports.OTP_LOGIN_MODE = OTP_LOGIN_MODE;

var checkStatus = function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = {
      status_code: response.status,
      status_text: response.statusText,
      data: response.json()
    };
    throw error;
  }
};

exports.checkStatus = checkStatus;

var parseJSON = function parseJSON(response) {
  return response.json();
};

exports.parseJSON = parseJSON;